import React from 'react';
import ExpandableListModule from "./ExpandableListModule";

const ThingsToKnow = (props) => {

    return (
        <div className="things-need-to-know">
            <ExpandableListModule title="Things you need to know" data={props.data} />
        </div>
    );

};

export default ThingsToKnow;


// WEBPACK FOOTER //
// ./resources/assets/js/modules/ThingsToKnow.js